<template>
  <div class="sharePic">
    <button
      @click="openShare('facebook')"
      data-sharer="facebook"
      data-hashtag="hashtag"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/facebook.svg">
    </button>
    <button
      @click="openShare('twitter')"
      data-sharer="twitter"
      data-hashtag="hashtag"
      :data-via="originApp"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/twiter.svg">
    </button>
    <button
      @click="openShare('sina')"
      data-sharer="weibo"
      :data-title="`【（分享来自 @人民日报英文客户端 ）]${shareTitle}`"
      :data-image="sharePicture"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/Weibo.svg">
    </button>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { useStore } from '@gx-vuex'
import { typeViteEnv } from '@/utils/env'

const store = useStore()

const localUrl = computed(() => location.href)

// @ts-ignore
const shareTitle = ref('')
// @ts-ignore
const sharePicture = ref('')

const originApp = ref(typeViteEnv('VITE_BASE_APP_ORIGIN'))
const objectType = document.querySelector('body').getAttribute('data-objectType')

onMounted(() => {
  try {
    // @ts-ignore
    shareTitle.value = shareInfo?.shareTitle
    // @ts-ignore
    sharePicture.value = shareInfo?.fullUrl || ''
    // @ts-ignore
    window.Sharer?.init()
  } catch (e) {
  
  }
  document.getElementById('sharePic').setAttribute('class', 'share-block')
  
  const el: any = document.querySelector('.live-time span')
  
  let time = el.innerText
  
  if (time) {
    time = dayjs(Number(time)).format('HH:mm, MMM DD, YYYY')
    el.innerText = time
    el.style.display = 'block'
  }
})

const openShare = (type: string) => {
  store.point.shareClick(type, Number(objectType))
}
</script>

<style lang="less" scoped>
.sharePic {
  display: flex;
  gap: 16px;
  
  button {
    width: 32px;
    height: 32px;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    
    img {
      width: 32px;
      height: 32px;
    }
  }
}

</style>
